export default __webpack_public_path__ + "static/media/Multi-Playing.2a662fe3.png";